import React, { useEffect, useMemo } from "react";
import { SectionHeader, TableAlerts } from "../../../../../app/components";
import Typography from "@material-ui/core/Typography";
import styled from "styled-components";
import ActivationProfilesTable from "./activationProfilesTable";
import SeparateContainer from "../../../../../app/components/separate.Container";
import SideBySide from "../../../../../app/components/sideBySide";
import { useActivationProfilesValidation } from "../../../../../app/hooks/activation.profiles/useActivationProfilesValidation";

const TOTAL_COLUMNS = 11;

const createEmptyProfile = (index) => ({
  siteActivationProfileId: `empty-${index}`,
  siteActivationLabel: "",
  siteActivationProfilePct: null,
  siteActivationProfileDays: null,
});
const SiteGroupActivationProfiles = ({ country, siteGroup, setHasErrors }) => {
  const {
    siteGroupId,
    activationProfiles: originalProfiles,
    milestones,
  } = siteGroup;
  const { countryId } = country;

  const FSIV = milestones?.find((m) => m.milestoneName === "DURATION_TO_FSIV");

  // Ensure we always have 11 profiles
  const activationProfiles = useMemo(() => {
    const profiles = [...(originalProfiles || [])];
    while (profiles.length < TOTAL_COLUMNS) {
      profiles.push(createEmptyProfile(profiles.length));
    }
    return profiles;
  }, [originalProfiles]);

  const { errorsArray, alerts } = useActivationProfilesValidation(activationProfiles);

  useEffect(() => {
    setHasErrors(errorsArray);
  }, [errorsArray, setHasErrors]);

  return (
    <SeparateContainer>
      <Container id="activation-profiles">
        <SideBySide>
          <SectionHeader
            paddingBottom={false}
            marginBottom={false}
          >
            Activation Profiles
          </SectionHeader>
        </SideBySide>
        <div
          style={{
            paddingInline: "20px",
            paddingTop: "10px",
            paddingBottom: "20px",
          }}
        >
          <Typography>
            Site ramp-up is modeled using the data below. Both the "# of Sites" and "Days" 
            can be updated to match the site ramp-up that is expected in this country for 
            this specific study. The "# of Sites" is the cumulative number of sites activated. 
            The days are the days since the First Site Activation. Ensure that the numbers 
            (both number of sites and days) increase from left to right, with the rightmost 
            values indicating when all sites are initiated.
          </Typography>
          <TableAlerts alerts={alerts} />
          <ActivationProfilesTable
            activationProfiles={activationProfiles}
            country={country}
            siteGroupId={siteGroupId}
            FSIV={FSIV}
            countryId={countryId}
            siteGroup={siteGroup}
          />
        </div>
      </Container>
    </SeparateContainer>
  );
};

export default SiteGroupActivationProfiles;

const Container = styled.div``;
